// const obj = { name: 'obj' };
// const obj2 = { name: 'obj2' };
// export default { obj, obj2 };

export const WebContent_QueryType_1_About="WebContent_QueryType_1_About";
export const WebContent_QueryType_2_Sign="WebContent_QueryType_2_Sign";
export const WebContent_QueryType_3_SignWording="WebContent_QueryType_3_SignWording";
export const WebContent_QueryType_4_Index="WebContent_QueryType_4_Index";
export const WebContent_QueryType_5_BookingStep1="WebContent_QueryType_5_BookingStep1";
export const WebContent_QueryType_6_BookingStep2="WebContent_QueryType_6_BookingStep2";
export const WebContent_QueryType_7_BookingStep3="WebContent_QueryType_7_BookingStep3";
export const WebContent_QueryType_8_BookingStep4="WebContent_QueryType_8_BookingStep4";
export const WebContent_QueryType_9_BookingStep5="WebContent_QueryType_9_BookingStep5";
export const WebContent_QueryType_10_Ebooks="WebContent_QueryType_10_Ebooks";

export const Setting_QueryType_SiteUrl="Setting_QueryType_SiteUrl";
export const Setting_QueryType_SiteTitle="Setting_QueryType_SiteTitle";
export const Setting_QueryType_SEO_site_name="Setting_QueryType_SEO_site_name";
export const Setting_QueryType_SEO_title="Setting_QueryType_SEO_title";
export const Setting_QueryType_SEO_description="Setting_QueryType_SEO_description";
export const Setting_QueryType_SEO_url="Setting_QueryType_SEO_url";
export const Setting_QueryType_SEO_image="Setting_QueryType_SEO_image";
export const Setting_QueryType_SiteTime="Setting_QueryType_SiteTime";
export const Setting_QueryType_SiteAddress="Setting_QueryType_SiteAddress";
export const Setting_QueryType_SiteGoogleMapUrl="Setting_QueryType_SiteGoogleMapUrl";
export const Setting_QueryType_Meta_Keyword="Setting_QueryType_Meta_Keyword";
export const Setting_QueryType_Meta_Description="Setting_QueryType_Meta_Description";
export const Setting_QueryType_Code="Setting_QueryType_Code";
export const Setting_QueryType_SMS_VerifyCode="Setting_QueryType_SMS_VerifyCode";
export const Setting_QueryType_SMS_OrderSuccess="Setting_QueryType_SMS_OrderSuccess";
export const Setting_QueryType_Disclaimer="Setting_QueryType_Disclaimer";
export const Setting_QueryType_Privacy="Setting_QueryType_Privacy";
export const Setting_QueryType_Payment="Setting_QueryType_Payment";
export const Setting_QueryType_Ship="Setting_QueryType_Ship";
export const Setting_QueryType_LoginSuccess="Setting_QueryType_LoginSuccess";
export const Setting_QueryType_ForgotSuccess="Setting_QueryType_ForgotSuccess";
export const Setting_QueryType_OrderSuccess="Setting_QueryType_OrderSuccess";
export const Setting_QueryType_ShipFee="Setting_QueryType_ShipFee";
export const Setting_QueryType_ShipFee2="Setting_QueryType_ShipFee2";
export const Setting_QueryType_ShipFeeTotalAmount="Setting_QueryType_ShipFeeTotalAmount";
export const Setting_QueryType_SMS_Order2Success="Setting_QueryType_SMS_Order2Success";
export const Setting_QueryType_EventDefine2="Setting_QueryType_EventDefine2";

export const SettingPage_QueryType_Index="SettingPage_QueryType_Index";
export const SettingPage_QueryType_About="SettingPage_QueryType_About";
export const SettingPage_QueryType_Event="SettingPage_QueryType_Event";
export const SettingPage_QueryType_Sign="SettingPage_QueryType_Sign";
export const SettingPage_QueryType_Ebooks="SettingPage_QueryType_Ebooks";

export const SettingPage_QueryType_BookingStep1="SettingPage_QueryType_BookingStep1";
export const SettingPage_QueryType_BookingStep2="SettingPage_QueryType_BookingStep2";
export const SettingPage_QueryType_BookingStep3="SettingPage_QueryType_BookingStep3";
export const SettingPage_QueryType_BookingStep4="SettingPage_QueryType_BookingStep4";
export const SettingPage_QueryType_BookingStep5="SettingPage_QueryType_BookingStep5";

export const SettingPage_QueryType_OrderStep1="SettingPage_QueryType_OrderStep1";
export const SettingPage_QueryType_OrderStep2="SettingPage_QueryType_OrderStep2";
export const SettingPage_QueryType_OrderStep3="SettingPage_QueryType_OrderStep3";

export const SettingPage_QueryType_Page_ProductList="SettingPage_QueryType_Page_ProductList";
export const SettingPage_QueryType_Page_ProductDetail="SettingPage_QueryType_Page_ProductDetail";
export const SettingPage_QueryType_Page_Register="SettingPage_QueryType_Page_Register";
export const SettingPage_QueryType_Page_Login="SettingPage_QueryType_Page_Login";
export const SettingPage_QueryType_Page_Forgot="SettingPage_QueryType_Page_Forgot";
export const SettingPage_QueryType_Page_Privacy="SettingPage_QueryType_Page_Privacy";
export const SettingPage_QueryType_Page_Disclaimer="SettingPage_QueryType_Page_Disclaimer";
